import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import classes from './Stepper.module.css';
import { useSelector } from 'react-redux';
import ArrowLeftWithCircle from '../../assests/course/arrowLeftWithCircle.png'
import { useLocation } from 'react-router-dom'
import { onKeyDown } from '../../service';
import DynamicMessage from '../lms-shared/UI/Popups/DynamicMessage/DynamicMessage';
import { DynamicMessageTypeEnum } from '../lms-shared/models/DynamicMessageTypeEnum';
/**
    * to do write docs
    */
const Stepper = ({ title, courseName, tocName, subTitle, canEditAll, children, arrowOnClick, onEnd }) => {
    const childRef = useRef();
    const navigate = useNavigate();
    const texts = useSelector(state => state.translate.texts);
    const direction = useSelector(state => state.translate.direction);
    const homeUrl = useSelector((state) => state.application.homeUrl);
    const location = useLocation();
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [doneStepIndex, setDoneStepIndex] = useState(0);
    const [currentStepValid, setCurrentStepValid] = useState(true);
    const [messagePopup, setMessagePopup] = useState()
    const [openOrCloseArrow, setOpenOrCloseArrow] = useState(false)

    validateStepperChildrenTree(children);

    useEffect(() => {
        if (canEditAll) {
            setDoneStepIndex(children.length)
        }
    }, [])

    // const prevStep = () => {
    //     if (currentStepIndex !== 0)
    //         setCurrentStepIndex(prevCurrentStepIndex => prevCurrentStepIndex - 1)
    // }

    const nextStep = async () => {
        if (currentStepIndex + 1 !== children.length) {
            // const validate = childRef.current.validateNext();
            if (!currentStepValid) {
                setMessagePopup(<DynamicMessage type={DynamicMessageTypeEnum.Error} confirmFunc={() => setMessagePopup(false)} content={texts.MessageContentNotFill} title={texts.MessageTitleErrorOccurred} />)
                // alert("not valid")
            } else {
                // children can implement functions to do in step next
                if (childRef.current && childRef.current.stepNext) {
                    await childRef.current.stepNext()
                }
                updateIndexes()
            }
        } else {
            // navigate to dashboard
            onEnd();
            // let studyGroupId = location.state ? location.state.studyGroupId : null
            // if (studyGroupId)
            //     navigate(`${homeUrl}/courses/${studyGroupId}`)
            // else
            //     navigate(`${homeUrl}/courses`)

        }
    }

    const updateIndexes = () => {
        if (currentStepIndex === doneStepIndex)
            setDoneStepIndex(prevDoneStepIndex => prevDoneStepIndex + 1)
        setCurrentStepIndex(prevCurrentStepIndex => prevCurrentStepIndex + 1)
    }

    const updateMinusIndexes = () => {
        if (currentStepIndex === doneStepIndex)
            setDoneStepIndex(prevDoneStepIndex => prevDoneStepIndex - 1)
        setCurrentStepIndex(prevCurrentStepIndex => prevCurrentStepIndex - 1)
    }

    const prevStep = () => {
        setCurrentStepValid(true)
        if (currentStepIndex - 1 >= 0) {
            updateMinusIndexes()
        } else {
            // navigate to dashboard
            navigate(`${homeUrl}/courses`)
        }
    }

    const getRightClass = (i) => {
        if (i === currentStepIndex)
            return "inProcees";
        if (i <= doneStepIndex)
            return "finished";
        if (i > doneStepIndex)
            return "notArrived";
    }

    const handleClickStep = (i) => {
        if (i <= doneStepIndex)
            setCurrentStepIndex(i)
    }

    return (
        <div className={`${classes.StepperWrap} ${classes[direction]}`}>
            <div className={`${classes.StepperProgressBarContainer} ${openOrCloseArrow ? classes.CloseArrow : classes.OpenArrow}`}>
                {/* <div className={classes.OpenOrCloseArrow} onClick={() => setOpenOrCloseArrow(prev => !prev)}>⟩</div> */}

                <div className={classes.StepperProgressBar}>
                    <div className={classes.ArrowContainer}>
                        <img className={classes.ArrowIcon} src={ArrowLeftWithCircle} alt="Arrow" onClick={() => { arrowOnClick && arrowOnClick() }} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => arrowOnClick && arrowOnClick())} />
                        {/* <p className={classes.ArrowText}> {arrowText}</p> */}
                        <div className={classes.Title}>{title}</div>
                    </div>

                    {courseName && tocName &&
                        <div className={classes.Details}>
                            <span className={`${classes.DetailName} ${classes.CName}`}>{courseName}</span>
                            <span >{">"}</span>
                            <span className={`${classes.DetailName} ${classes.TName}`}>{tocName}</span>
                        </div>
                    }

                    <div className={classes.SubTitle}>{subTitle}</div>
                    <div className={classes.Steps}>
                        {children && children.map((step, i) => <div key={i} className={`${classes.StepWrap} ${classes[getRightClass(i)]}`} onClick={() => handleClickStep(i)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleClickStep(i))}>
                            <div className={classes.Name}>{(i + 1) === children.length ? texts.finish : (i + 1)}</div>
                            <div className={classes.Description}>{step.props.description}</div>
                        </div>)}
                    </div>
                </div>
            </div>

            <div className={classes.StepContent}>
                <h1 className={classes.ContentTiltle}>
                    {(currentStepIndex + 1) !== children.length ? `${currentStepIndex + 1}. ${children[currentStepIndex].props.description}` : `${texts.finish}`}
                </h1>
                <div className={classes.ContentComp}>
                    {React.cloneElement(children[currentStepIndex].props.children, {
                        setValid: setCurrentStepValid,
                        ref: childRef
                    })}
                </div>
                <div className={classes.Btns}>
                    {currentStepIndex !== 0 && <button className={`${classes.Btn} ${classes.BtnPrev}`} onClick={prevStep}>{texts.prev}</button>}
                    {children[currentStepIndex].props.skipButton && <button className={`${classes.Btn} ${classes.BtnSkip}`} onClick={updateIndexes}>{texts.skip}</button>}
                    {currentStepIndex + 1 !== children.length && <button className={`${classes.Btn} ${classes.BtnNext}`} onClick={nextStep}>{children[currentStepIndex].props.buttonText}</button>}
                    {currentStepIndex + 1 === children.length && <button className={`${classes.Btn} ${classes.BtnNext}`} onClick={nextStep}>{texts.end}</button>}
                </div>
            </div>
            {messagePopup}
        </div>)
}

Stepper.propTypes = {
    title: PropTypes.string
}

const Step = ({ description, next, children }) => null;

Step.propTypes = {
    description: PropTypes.string,
    next: PropTypes.func
};

const validateStepperChildrenTree = (children) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        let error;
        if (((children instanceof Array && children.some(f => f.type !== Step)) || (!(children instanceof Array) && children.type !== Step)))
            error = "Stepper has children that aren't Step component";
        else if (((children instanceof Array && children.some(f => f.props.children instanceof Array)) || (!(children instanceof Array) && children.props.children instanceof Array)))
            error = "Step expect exactly 1 children"
        if (error)
            throw new Error(`${error} note that there are no unnecessary spaces`);
    }
}

export { Stepper, Step };